//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goConsultant from '@/common/mixins/goConsultant'
import callConsultant from '@/common/mixins/callConsultant'
import { openChat } from '@/data/im'
import { CONSULATANT_CARD_IS_CALL } from '@/constant'

export default {
    mixins: [
        goConsultant,
        callConsultant
    ],
    props: {
        title: {
            type: String
        },
        show_help: {
            type: Boolean,
            default: false
        },
        excellent_consultants: {
            type: Array,
            default: []
        },
        is_default: {
            type: Boolean,
            default: true
        },
        building_id: {
            type: [Number, String]
        },
        show_consultants_auth: {
            type: Boolean,
            default: true
        },
        show_gomore: {
            type: Boolean,
            default: true
        },
        page: String
    },

    methods: {
        goConsultantHelp () {
            this.$router.push({
                path:`/consultants/recommend_rules/main?building_id=${this.building_id}`
            })
        },
        onConsult (id) {
            openChat(id, {
                building_id: this.building_id,
                from: this.page || ''
            })
        }
    }
}
